// extracted by mini-css-extract-plugin
export var buttonsContainer = "SubmissionForm_buttonsContainer__2ux+7";
export var container = "SubmissionForm_container__OPQ9k";
export var errorContainer = "SubmissionForm_errorContainer__RrxiC";
export var errorTextArea = "SubmissionForm_errorTextArea__yH4Jn";
export var generalSubtitle = "SubmissionForm_generalSubtitle__sqQZ2";
export var infoContainer = "SubmissionForm_infoContainer__UXY0T";
export var infoLight = "SubmissionForm_infoLight__52-hm";
export var paragraph = "SubmissionForm_paragraph__8ZTlP";
export var paragraphLight = "SubmissionForm_paragraphLight__dmM7q";
export var productBrandName = "SubmissionForm_productBrandName__-htaq";
export var productImage = "SubmissionForm_productImage__TdIrv";
export var productName = "SubmissionForm_productName__YwaAI";
export var productSummaryContainer = "SubmissionForm_productSummaryContainer__2bVOY";
export var productTitleContainer = "SubmissionForm_productTitleContainer__nBsxZ";
export var secondaryTitle = "SubmissionForm_secondaryTitle__XepL6";
export var starsContainer = "SubmissionForm_starsContainer__OJjCA";
export var textArea = "SubmissionForm_textArea__0BU3A";
export var title = "SubmissionForm_title__8MD-g";